<template>
  <HeaderView active="2" />

  <div id="main-content">

    <div class="et_pb_section title_section">
      <div class="et_pb_row">
        <div class="et_pb_column">
          <div class="et_pb_module mb0">
            <h1>联系我们</h1>
          </div>
        </div>
      </div>
    </div>

    <div class="et_pb_section a_text pv54 pb0 sec1">
      <div class="et_pb_row">
        <div class="et_pb_column col-large3">
          <div class="et_pb_module ms3">
            <h2 class="left ff0">Contact Form</h2>
          </div>

          <div class="et_pb_module">

            <div class="gf_browser_chrome gform_wrapper" id="gform_wrapper_1">
              <form method="post" enctype="multipart/form-data" id="gform_1" action="/careers/">
                <input type="hidden" class="gforms-pum"
                  value="{&quot;closepopup&quot;:false,&quot;closedelay&quot;:0,&quot;openpopup&quot;:false,&quot;openpopup_id&quot;:0}">
                <div class="gform_body">
                  <ul class="gform_fields">
                    <li class="gfield gfield_required">
                      <label class="gfield_label" for="input_1_1">Name<span class="gfield_required">*</span></label>
                      <div class="ginput_container ginput_container_text">
                        <input name="input_1" id="input_1_1" type="text" value="" class="large" aria-required="true"
                          aria-invalid="false">
                      </div>
                    </li>
                    <li id="field_1_3" class="gfield gfield_required">
                      <label class="gfield_label" for="input_1_3">Email<span class="gfield_required">*</span></label>
                      <div class="ginput_container ginput_container_email">
                        <input name="input_3" id="input_1_3" type="text" value="" class="large" aria-required="true"
                          aria-invalid="false">
                      </div>
                    </li>
                    <li id="field_1_4" class="gfield"><label class="gfield_label" for="input_1_4">Country Code</label>
                      <div class="ginput_container ginput_container_phone">
                        <input name="input_4" id="input_1_4" type="text" value="" class="small" aria-invalid="false">
                      </div>
                    </li>
                    <li id="field_1_5" class="gfield"><label class="gfield_label" for="input_1_5">Phone Number</label>
                      <div class="ginput_container ginput_container_phone">
                        <input name="input_4" id="input_1_5" type="text" value="" class="large" aria-invalid="false">
                      </div>
                    </li>
                    <li id="field_1_5" class="gfield gfield_required">
                      <label class="gfield_label" for="input_1_5">Message<span class="gfield_required">*</span></label>
                      <div class="ginput_container ginput_container_textarea">
                        <textarea name="input_5" id="input_1_5" class="textarea medium" aria-required="true"
                          aria-invalid="false" rows="10" cols="50"></textarea>
                      </div>
                    </li>
                    <!-- <li id="field_1_8"
                      class="gfield field_sublabel_below field_description_below hidden_label gfield_visibility_visible">
                      <label class="gfield_label" for="input_1_8">CAPTCHA</label>
                      <div id="input_1_8" class="ginput_container ginput_recaptcha"
                        data-sitekey="6Le-RQweAAAAAOShSDejSuN3u5FReI94cpqDdXM8" data-theme="light" data-tabindex="0"
                        data-badge=""></div>
                    </li>
                    <li id="field_1_9" class="gfield gform_validation_container">
                      <label class="gfield_label" for="input_1_9">Comments</label>
                      <div class="ginput_container"><input name="input_9" id="input_1_9" type="text" value=""></div>
                      <div class="gfield_description" id="gfield_description__9">This field is for validation purposes
                        and should be left unchanged.</div>
                    </li> -->
                  </ul>
                </div>
                <div class="gform_footer">
                  <input type="submit" id="gform_submit_button_1" class="gform_button" value="Submit"
                    onclick="if(window[&quot;gf_submitting_1&quot;]){return false;}  window[&quot;gf_submitting_1&quot;]=true;  "
                    onkeypress="if( event.keyCode == 13 ){ if(window[&quot;gf_submitting_1&quot;]){return false;} window[&quot;gf_submitting_1&quot;]=true;  jQuery(&quot;#gform_1&quot;).trigger(&quot;submit&quot;,[true]); }">
                  <input type="hidden" class="gform_hidden" name="is_submit_1" value="1">
                  <input type="hidden" class="gform_hidden" name="gform_submit" value="1">

                  <input type="hidden" class="gform_hidden" name="gform_unique_id" value="">
                  <input type="hidden" class="gform_hidden" name="state_1"
                    value="WyJbXSIsImI0NjY3N2Y2NGQ1NDE5MWJmMzIyMzcyMzRkZWNhYTAxIl0=">
                  <input type="hidden" class="gform_hidden" name="gform_target_page_number_1"
                    id="gform_target_page_number_1" value="0">
                  <input type="hidden" class="gform_hidden" name="gform_source_page_number_1"
                    id="gform_source_page_number_1" value="1">
                  <input type="hidden" name="gform_field_values" value="">
                </div>
              </form>
            </div>

          </div>
        </div>

        <div class="et_pb_column col-small3 vtop">
          <div class="et_pb_module et_pb_image">
          </div>

        </div>

      </div>
    </div>

    <div class="et_pb_section pv54 sec0">
      <div class="et_pb_row row0">
        <div class="et_pb_column col_0_1 vcenter col-small2">
          <div class="et_pb_module">
            <h2 class="ff0 lh13">China<br>Distributor</h2>
          </div>
        </div>

        <div class="et_pb_column col-half">
          <div class="et_pb_module pd20 lh17 a0c7">
            <h3>成都纳瑟可科技有限公司</h3>
            <p><strong>地址</strong>: 四川省成都市双流区新川路706号创智广场C座5A04<br>
              <strong>电话</strong>: 88612997<br>
              <!-- <strong>Website: </strong> <a href="http://www.sunus-hk.com/">www.sunus-hk.com</a> -->
            </p>
          </div>
        </div>

        <div class="et_pb_column col-small2">
          <div class="et_pb_module et_pb_image pd20">
            <img loading="lazy" decoding="async" width="202" height="63"
              :src="img_log2" class="wp-image-1335">
          </div>
        </div>

      </div>
    </div>

  </div>

  <FooterView />
</template>

<script>
import HeaderView from "../components/Header.vue";
import FooterView from "../components/Footer.vue";
import img_log2 from "@/assets/logo2.png";

export default {
  components: {
    HeaderView,
    FooterView
  },
  data() {
    return {
      img_log2
    }
  },

}
</script>

<style scoped>
.row0 {
  background-color: #F5F5F5;
  border-bottom-color: #d3d3d3;
}

.col_0_1 {
  background-color: #193668;
  border-right-width: 1px;
  border-right-color: #bfbfbf;
}

.col_0_1 .et_pb_module {
  margin: 10px 0 0;
}

.sec0 h2 {
  font-weight: 600;
  font-size: 23px;
  color: #fff;
  line-height: 1em;
}

.sec0 h3 {
  font-weight: 600;
  font-size: 18px;
  color: #333;
  text-transform: uppercase;
}

.pd20 {
  padding: 20px;
  margin-bottom: 0;
}

.et_pb_module.ms3 {
  margin-bottom: 4.758%;
}

.sec1 h2 {
  font-size: 26px;
  color: #333;
  text-transform: none;
}

.sec0.pb2 {
  padding-bottom: 2px;
}

h2.lh13 {
    line-height: 1.3em;
}
</style>
